import {APIURL} from '../../constants';
import axios from 'axios';
import {translater} from '../../tools/translate';
import {parseFileName} from '../../tools/';

export default {
	namespaced: true,
	state: {
		showEditCheckpointDialog: false,
		checkPoint: undefined,
		isFetching: false,
		isFetchingSlide: false,
		add: false,
		isCheckingIfExists: false,
		slide: '',
		//defaultSeasonsSet: false,
		//season: 0,
		seasons: [
			{text: translater.__('Winter', 'seasons'), type: 'winter'},
			{text: translater.__('Spring', 'seasons'), type: 'spring'},
			{text: translater.__('Summer', 'seasons'), type: 'summer'},
			{text: translater.__('Autumn', 'seasons'), type: 'autumn'}

		],
		//uploadImageAnswer: false,

		audioTaskImageAnswerMimeTypes: {
			'image/png': ['png']
		},

		
		

		validMimeTypes: {
			6: {
				mimeTypes: {
					'image/jpeg': ['jpg', 'jpeg'],
					'image/png': ['png']
				}
			},

			20: {
				mimeTypes: {
					'image/jpeg': ['jpg', 'jpeg'],
					'image/png': ['png']
				}
			},

			4: {
				mimeTypes: {
					'audio/mp3': ['mp3'],
					'audio/mpeg': ['mp3']
				}
			},

			7: {
				mimeTypes: {
					'video/mp4': ['mp4']
				}
			},
			12: {
				mimeTypes: {
					'video/mp4': ['mp4']
				}
			},
			14: {
				mimeTypes: {
					'video/mp4': ['mp4']
				}
			},

			15: {
				mimeTypes: {
					'image/jpeg': ['jpg', 'jpeg'],
					'image/png': ['png']
				}
			},

			17: {
				mimeTypes: {
					'video/mp4': ['mp4']
				}
			},
		},

		newTask: {
			type: 0,
			question: {
				content: '',
				description: ''
			},

			answers: undefined
		},

		editableTask: {
			type: undefined,
			question: {
				content: '',
				description: ''

			}
		},

		taskTypes: [
			{value: 0, text: translater.__('Text', 'tasks'), src: '/images/icon_text-01.png'},
			//{value: 6, text: translater.__('Image', 'tasktypes')},
			{value: 21, text: translater.__('Single Image', 'tasks'), src: '/images/icon_singleimage-01.png'},
			{value: 20, text: translater.__('Image', 'tasks'), src: '/images/icon_image-01.png'},
			{value: 4, text: translater.__('Audio', 'tasks'), src: '/images/icon_audio-01.png'},
			{value: 7, text: translater.__('Full Screen Video', 'tasks'), src: '/images/icon_fullscreenvideo-01.png'},
			{value: 19, text: translater.__('Youtube Video', 'tasks'), src: '/images/icon_youtubevideo-01.png'},
			{value: 17, text: translater.__('Video', 'tasks'), src: '/images/icon_video-01.png'},
			{value: 12, text: translater.__('360 Video', 'tasks'), src: '/images/icon_360video-01.png'},
			{value: 13, text: translater.__('Info slides', 'tasks'), src: '/images/icon_infoslides-01.png'},
			{value: 14, text: translater.__('Season Video', 'tasks'), src: '/images/icon_seasonvideo-01.png'},
			{value: 15, text: translater.__('Camera', 'tasks'), src: '/images/icon_camera-01.png'},
			{value: 18, text: translater.__('Feedback', 'tasks'), src: '/images/icon_feedback-01.png'}

		],
		
		paths: {
			6: 'images',
			20: 'images',
			21: 'images', 
			4: 'audio',
			7: 'videos', 
			12: '360videos', 
			14: '360videos',
			15: 'images',
			17: 'videos'
		},


		// upload specific
		//isUploading: false,
		// upload specific
		filesToUpload: [],
		// upload specific
		uploadedFiles: [],
		//existingImages: {}
		isEditingSlide: false,
		editableSlide: undefined,
		video: {
			full: undefined,
			url: undefined
		},

		editTask: false,
		isBeingReplaced: false,
		removableTask:  undefined
		
		
		
	},


	actions: {

		updateLatLng(context, payload) {
            const url = `${APIURL}trackinglocations/${payload.id}/latlng`;

            return axios.patch(url, payload);
        },

		getItem(context, payload) 
		{
			return axios.get(`${APIURL}trackinglocations/${payload._id}`);
		},


		restoreTask(context, payload)
		{
			let url = APIURL + 'checkpoints/' + context.state.checkPoint._id + '/' + payload._id + '/restore' ;
			axios.patch(url).then((res) => {
				if(res.status === 200)
				{
					context.dispatch('checkPoint', context.state.checkPoint);
				}
			}).catch((err) => {
				console.log(err)
			})
		},

		



		setCheckpoint(context, payload)
		{
			context.commit('setCheckpoint', payload);
			//context.dispatch('routes/setCheckpoint', context.state.checkPoint, {root:true})

		},

		reorder(context, payload)
		{
			//console.log(context.state)
			axios.patch(`${APIURL}checkpoints/${context.state.checkPoint._id}/reorder`, payload).then((res) => {
				//console.log("reorder", res.data)
			}).catch((err) => {
				console.log(err);
			})
		},

		destroyTask(context, payload)
		{
			let url = APIURL + 'checkpoints/' + context.state.checkPoint._id + '/' + payload.st._id;
			if(payload.hardDelete){
				url += '?hard=1'
			}

			console.log("####### destroyTask", url)
			axios.delete(url)
			.then((res) => {
				if(res.status === 200)
				{
					console.log(context.state.checkPoint)
					context.dispatch('checkPoint', context.state.checkPoint)
					context.dispatch('status/updateResources', 'routedata', {root:true})
				}
			}).catch((err) => {
				console.log(err)
			})
		},

		removeTask(context, payload)
		{
			let found = context.state.checkPoint.properties.subTasks.find((st) => {
				return st._id === payload.task._id
			})

			if(found)
			{
				context.commit('removeTask', payload)
				//context.dispatch('routes/setCheckpoint', context.state.checkPoint, {root: true})
			}
		},

		deleteFile(context, payload)
		{
			
			let editableTask = context.state.editableTask;
			
			let found = Object.keys(editableTask.question.files).find((f) => {
				return f === payload;
			})

			if(found)
			{
				const root = true;
				context.commit('deleteFile', found);
				context.dispatch('checkpointsValidator/validateSeasonVideoTaskEdit', undefined, {root})
					.then((valid) => {
						context.commit('checkpointsValidator/setValidEdit', valid, {root});
					}).catch((validationErr) => {

				})
				

				
			}

			
			


		},

		cancelSeasonVideoIsBeinReplaced(context)
		{
			context.dispatch('cancelIsBeingReplacedGlobal');
			let editableTask = context.state.editableTask;
			let found = Object.keys(editableTask.question.files).find((f) => {
				return editableTask.question.files[f].isBeingReplaced === true;
			});

			if(found)
			{
				context.commit('cancelSeasonVideoIsBeinReplaced', found)
			}
		},

		replaceSingleImage(context, payload)
		{
			context.commit('files/setIsUploading', false, {root: true});

			let editableTask = context.state.editableTask;
			let file = editableTask.question.files[0]
			let route = context.rootGetters['routes/route'];

			file = {
				path: 'images/' + route.name + '/' + payload
			}

			context.commit('replaceSingleImage', file)
						

		},

		replaceUploadedSeasonVideoFile(context, payload)
		{
			context.commit('files/setIsUploading', false, {root: true});

			let editableTask = context.state.editableTask;
			let files = editableTask.question.files

			let found = Object.keys(files).find((f) => {
				return files[f].isBeingReplaced === true;
			})

			if(found)
			{
				let i = Object.keys(files).findIndex((f) => {
					return found === f;
				})
				context.commit('replaceUploadedSeasonVideoFile', {old: found, new: payload, i: i})
				context.commit('setSeasonVideoIsBeingReplaced', {value: false, name: payload})
				context.commit('files/setIsUploading', false, {root: true})
			}
		},

		addSeasonAnswer(context, payload)
		{
			let filesToUpload = context.rootGetters['files/filesToUpload'];
			context.commit('addSeasonAnswer', {file: payload, files: filesToUpload});

		},

		setSeasonErrors(context)
		{
			let duplicates = [];
			/*context.state.filesToUpload.forEach((f) => {
				let filtered = context.state.filesToUpload.filter((ftu) => {
					return f.name !== ftu.name
					&& f.season.value === ftu.season.value
				})

				duplicates = duplicates.concat(filtered)
			})*/
			let answers = context.state.newTask.answers
			Object.keys(answers).forEach((a) => {
				let filtered = Object.keys(answers).filter((aa) => {
					return a !== aa
					&& answers[a].type === answers[aa].type;
				})

				duplicates = duplicates.concat(filtered)
			})

			//console.log("setSeasonErrors", duplicates)

			context.commit('setSeasonErrors', duplicates)


		},

		setSeasonErrorsEdit(context)
		{
			let duplicates = [];

			let files = context.state.editableTask.question.files;
			Object.keys(files).forEach((f) => {
				let filtered = Object.keys(files).filter((ff) => {
					return f !== ff
					&& files[f].type === files[ff].type
					&& files[f].delete !== true
				});

				duplicates = duplicates.concat(filtered);
			});


			//console.log("####### setSeasonErrorEdit", duplicates)
			context.commit('setSeasonErrorsEdit', duplicates)
		},

		setSeason(context, payload)
		{
			context.commit('flushSeasonErrors');
			let newTask = context.state.newTask;

			if(typeof newTask.answers[payload.f.name] !== 'undefined'
			&& payload.c <= context.state.seasons.length)
			{
				context.commit('setSeason', payload)
				context.dispatch('setSeasonErrors');

			}

			

		},

		setSeasonEdit(context, payload)
		{
			context.commit('flushSeasonErrorsEdit');
			let editableTask = context.state.editableTask;

			if(typeof editableTask.question.files[payload.f] !== 'undefined'
				&& payload.c <= context.state.seasons.length){
				context.commit('setSeasonEdit', payload)
				context.dispatch('setSeasonErrorsEdit');

			}
		},

		
		replaceUploadedVideoFile(context, payload)
		{
			
			let editableTask = context.state.editableTask;

			if(
				typeof editableTask.question !== 'undefined'
				&& typeof editableTask.question.files !== 'undefined'
				 
			) {

				

				let path = context.state.paths[editableTask.type] + '/' + context.rootGetters['routes/route'].name + '/' + payload
				context.commit('files/setIsUploading', false, {root:true})
				context.commit('replaceUploadedVideoFile', path)
					
					
				
			}
		},

		setIsBeingReplacedGlobal(context, payload)
		{
			context.commit('files/flushFilesToUpload', undefined, {root: true})
			context.commit('setIsBeingReplacedGlobal', payload);

			
		},

		cancelIsBeingReplacedGlobal(context, payload)
		{
			context.commit('setIsBeingReplacedGlobal', false)
		},
		

		replaceUploadedAudioTaskImage(context, payload)
		{
			let editableTask = context.state.editableTask;

			let keys = Object.keys(editableTask.question.answers);
			let found = keys.find((k) => {
				return editableTask.question.answers[k].matchingImage.isBeingReplaced === true;
			})



			if(found)
			{
				let old = editableTask.question.answers[found].matchingImage.path;
				let path = context.state.paths[6] + '/' + context.rootGetters['routes/route'].name  + '/';

				context.commit('replaceUploadedAudioTaskImage', {audio: found, old: old, new: payload, path: path})
				context.commit('setAnswerImageIsBeingReplaced', {value: false, name: found})
				context.commit('files/setIsUploading', false, {root: true})
			} 
		},
		
		
		replaceUploadedFile(context, payload)
		{
			

			let editableTask = context.state.editableTask;

			let keys = Object.keys(editableTask.question.answers);
			let found = keys.find((k) => {
				return editableTask.question.answers[k].isBeingReplaced === true;
			})

			if(found)
			{
				let  i = keys.findIndex((k) => {
					return k === found;
				})

				context.commit('replaceUploadedFile', {old: found, new: payload, i: i})
				context.commit('files/setIsUploading', false, {root: true})
				context.commit('setIsBeingReplaced', {value: false, name: payload})
			} 

			
		},

		cancelAnswerImageIsBeingReplaced(context, payload)
		{
			
			context.dispatch('setIsBeingReplaced', {
				name: payload.name,
				value: false,
				answerImage: true
			});
		},


		setSeasonVideoIsBeingReplaced(context, payload)
		{

			context.dispatch('setIsBeingReplacedGlobal', true);
			let editableTask = context.state.editableTask;
			let files = editableTask.question.files;
			let found = Object.keys(files).find((f) => {
				return f === payload.name;
			})

			if(found)
			{
				context.commit('setSeasonVideoIsBeingReplaced', payload)
			}
		},

		setIsBeingReplaced(context, payload)
		{
			context.commit('files/flushFilesToUpload', undefined, {root: true});
			
			if(typeof context.state.editableTask.question.answers !== 'undefined')
			{
				let keys = Object.keys(context.state.editableTask.question.answers);

				let found = keys.find((k) => {
					return k == payload.name;
				})




				if(found)
				{
					if(payload.answerImage !== true){
						
						context.commit('setIsBeingReplaced', payload)
					} else {
						
						context.commit('setAnswerImageIsBeingReplaced', payload)
					}
				}
			}
		},

		updateTask(context)
		{

			let route = context.rootGetters['routes/route'].name
			let checkPoint = context.state.checkPoint;
			axios.put(APIURL + 'checkpoints/' + checkPoint._id + '/' + context.state.editableTask._id, 
				{task: context.state.editableTask, route: route})
			.then((res) => {

				context.dispatch('setCheckpoint', res.data);
				context.commit('setEditTask', false);
				context.dispatch('status/updateResources', 'routedata', {root:true})
				context.commit('setIsBeingReplacedGlobal', false)
			})
			.catch((err) => {
				console.log(err);
			})
		},



		setEditableTaskDescription(context, payload)
		{
			//console.log("setEditableTaskDescription", payload)
			context.commit('setEditableTaskDescription', payload)
		},

		setEditableTaskContent(context, payload)
		{
			context.commit('setEditableTaskContent', payload)
		},

		setEditTask(context, payload)
		{
			if(payload === false)
			{
				context.commit('setIsBeingReplacedGlobal', false)
			}
			context.commit('setEditTask', payload)
		},

		editTask(context, payload)
		{
			
			context.commit('setIsFetching', true)
			context.commit('files/setIsUploading', false, {root: true})
			context.commit('files/flushFilesToUpload', undefined, {root: true})
			let checkPoint = context.rootGetters['checkpoints/checkPoint'];
			axios.get(APIURL + 'checkpoints/' + checkPoint._id + '/' + payload._id)
			.then((res) => {
				
				if(res.data.type == 13)
				{
					context.commit('setSlides', res.data)
				}

				else if(res.data.type == 14)
				{
					context.commit('setSeasonVideos', {task: res.data, route: context.rootGetters['routes/route'].name})

				} else if(res.data.type == 15)
				{
					context.commit('setCameraTask', res.data)
				} 
				else {

					context.commit('editTask', res.data)
				}
				context.commit('setIsFetching', false);
			})
			.catch((err) => {
				console.log(err)
			})
		},

		flushVideo(context)
		{
			context.commit('flushVideo')
		},

		storeYoutubeVideoTask(context)
		{
			let files = [];
			files[0] = {
				path: context.state.video.url
			}
			let task = {
				question: {
					content: 'YoutubeVideo',
					files: files
				},
				type: 19
			};

			let payload = {}
			payload.tasks = [task];
			payload.checkPoint = context.state.checkPoint;
			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				//console.log(res.data)
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
				context.dispatch('flushVideo')
				//context.dispatch('status/updateResources', 'routedata', {root:true})
			})
			.catch((err) => {
				console.log(err);
			})
		},

		setVideo(context, payload)
		{
			// set video url separately if is valid
			context.commit('setVideoFull', payload)
			context.dispatch('checkpointsValidator/validateYoutubeVideoTask', payload, {root: true})
			.then((validation) => {
				//console.log("setVideo::validation", validation)
				context.commit('checkpointsValidator/setValid', validation.valid, {root: true})
				if(validation.valid === true && typeof validation.url !== 'undefined')
				{
					context.commit('setVideoUrl', validation.url)
				}
				
			})
		},

		storeCameraTask(context, mode)
		{
			let tasks = [];
			tasks[0] = {
				type: 15,
				question: {
					content: 'Camera'
				}
			};

			let uploadedFiles = context.rootGetters['files/filesToUpload'].filter((ftu) => {
				return ftu.uploaded === true;
			})

			


			let answers = uploadedFiles.map((ftu) => {
				let answer = {
					description: context.state.newTask.answers[ftu.name],
					path: context.state.paths[6] + '/' + context.rootGetters['routes/route'].name +'/' + parseFileName(ftu.name),
					type: 2,
					mode: mode
				}

				return answer
			})

			answers.push({
				type: 2,
				content: undefined,
				path: undefined

			})

			tasks[1] = {
				type: 16,
				question: {
					content: 'CameraSlider',
					answers: answers

				},
				
			};

			let payload = {};
			payload.tasks = tasks;
			payload.checkPoint = context.state.checkPoint;
			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
			})
		},

		deleteSlide(context, payload)
		{
			let answers = context.state.newTask.answers;
			if(payload.edit === true)
			{
				answers = context.state.editableTask.question.answers;
			}
			if(typeof answers !== 'undefined' &&
				typeof answers[payload.key] !== 'undefined')
			{
				//context.commit('setIsFetching', true);
				context.commit('deleteSlide', payload)
			}
		},

		cancelDeleteSlide(context, payload)
		{
			let answers = context.state.newTask.answers;
			if(payload.edit === true)
			{
				answers = context.state.editableTask.question.answers
			}
			if(typeof answers !== 'undefined' &&
				typeof answers[payload.key] !== 'undefined')
			{
				//context.commit('setIsFetching', true);
				context.commit('cancelDeleteSlide', payload)
			}
		},

		confirmSlideDelete(context, payload)
		{
			let answers = context.state.newTask.answers
			if(payload.edit === true)
			{
				answers = context.state.editableTask.question.answers;
			}
			if(typeof answers !== 'undefined' &&
				typeof answers[payload.key] !== 'undefined')
			{
				//context.commit('setIsFetching', true);
				context.commit('confirmSlideDelete', payload)
			}
		},

		updateSlide(context, payload)
		{
			context.commit('updateSlide', payload)
		},

		setIsEditingSlide(context, payload)
		{
			context.commit('setIsEditingSlide', payload)
		},

		editSlide(context, payload)
		{
			let t = context.state.newTask;
			let answers = t.answers;
			let mutation = 'editSlide';

			if(payload.edit === true)
			{
				t = context.state.editableTask;
				answers = t.question.answers
				mutation = 'editSlideEdit';
			}
			if(typeof answers !== 'undefined' &&
				typeof answers[payload.key] !== 'undefined')
			{
				//console.log("editSlide souma", answers)
				context.commit('setIsFetchingSlide', true);
				context.commit(mutation, payload)
			}
		},
		// upload specific
		/*setIsUploading(context)
		{
			let isUploading = true;
			let files = context.state.filesToUpload;
			let validFiles = files.filter((f) => {
				return typeof f.error === 'undefined'
			});
			console.log("########setIsUploading", validFiles.length, files.length)
			if(validFiles.length == files.length)
			{
				isUploading = false;
			}

			context.commit('setIsUploading', isUploading)

		},*/

		

		

		setSlide(context, payload)
		{
			context.commit('setSlide', payload)
		},

		addSlide(context, payload)
		{
			let action = 'setNewTaskAnswer';
			if(payload.edit === true)
			{
				action = 'setEditableTaskAnswer';
			}
			context.dispatch(action, 
				{value: {
					content: payload.content,
					edit: false,
					delete: false
				}, 
					name: new Date().getTime()})


			
			
		},
		
		

		

		

		setNewTaskAnswer(context, payload)
		{
			context.commit('setNewTaskAnswer', payload)
		},

		setEditableTaskAnswer(context, payload)
		{
			context.commit('setEditableTaskAnswer', payload)
		},

		setEditableAudioTaskAnswer(context, payload)
		{
			//context.commit('setEditableAudioTaskAnswer', payload)
			if(typeof context.state.editableTask !== 'undefined'
			&& typeof context.state.editableTask.question !== 'undefined'
			&& typeof context.state.editableTask.question.answers !== 'undefined' 
			&& typeof context.state.editableTask.question.answers[payload.name] !== 'undefined')
			{
				context.commit('setEditableAudioTaskAnswer', payload)
			}
		},
		

		storeSeasonVideoTask(context)
		{

			let tasks = []
			/*let files = context.rootGetters['files/filesToUpload'].map((ftu) => {
				let file = {
					type: context.state.seasons[ftu.season.value].type,
					path: context.state.paths[context.state.newTask.type] + '/' + context.rootGetters['routes/route'].name +'/' + ftu.name
				}

				return file;
			})*/

			let answers = context.state.newTask.answers
			let files = Object.keys(answers).map((a) => {
				let file = {
					type: answers[a].type,
					path: context.state.paths[context.state.newTask.type] + '/' + context.rootGetters['routes/route'].name +'/' + parseFileName(a)
				};

				return file
			})

			tasks[0] = {
				type: 14,
				question: {
					files: files
				}
			}

			

			let payload = {};
			payload.tasks = tasks;
			payload.checkPoint = context.state.checkPoint;
			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
				//context.commit('flushAudioTaskAnswerImagesToUpload')
			})
			.catch((err) => {
				console.log("storeVideoTask::err", err);
			})
			
		},

		storeVideoTask(context)
		{
			let ftu = context.rootGetters['files/filesToUpload'][0]
			let task = {
				type: context.state.newTask.type,
				question: {
					files: [
						{
							path: context.state.paths[context.state.newTask.type] + '/' + context.rootGetters['routes/route'].name +'/' + parseFileName(ftu.name)
						}
					]
				}
			}

			let payload = {};
			payload.tasks = [task];
			payload.checkPoint = context.state.checkPoint;
			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				//console.log("storeVideoTask res", res.data);
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
				//context.commit('flushAudioTaskAnswerImagesToUpload')
			})
			.catch((err) => {
				console.log("storeVideoTask::err", err);
			})
		}, 

		storeAudioTask(context)
		{
			let tasks = [];
			let uploadedFiles = context.rootGetters['files/filesToUpload'].filter((ftu) => {
				return ftu.uploaded === true;
			})
			let files = uploadedFiles.map((ftu) => {
				let file = {
					path: context.state.paths[4] + '/' + context.rootGetters['routes/route'].name +'/' + parseFileName(ftu.name),
					correctAnswer: context.state.newTask.answers[ftu.name]
				}

				return file;
			});
			tasks[0] = {
				type: 4,
				question: {
					content: 'SelectAudio',
					files: files
				}
			};

			let answers = uploadedFiles.map((ftu) => {
				let answer = {
					content: context.state.newTask.answers[ftu.name]
				}

				return answer
			});

			tasks[1] = {
				type: 5,
				question: {
					content: context.state.newTask.question.content,
					description: context.state.newTask.question.description,
					answers: answers
				}
			}

			files = uploadedFiles.map((ftu) => {
				let n = {};
				n[window.localStorage.getItem('lang')] = context.state.newTask.answers[ftu.name]
				let file = {
					path: context.state.paths[6] + '/' + context.rootGetters['routes/route'].name +'/' + parseFileName(ftu.matchingImage),
					name: n
				}

				return file;
			});

			tasks[2] = {
				type: 11,
				question: {
					content: "ImageAnswer",
					files: files
				}
			}

			

			let payload = {};
			payload.tasks = tasks;
			payload.checkPoint = context.state.checkPoint;
			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				//console.log("storeAudio res", res.data);
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
				context.commit('flushAudioTaskAnswerImagesToUpload')
			})

			


		},

		storeSingleImageTask(context)
		{
			let uploadedFiles = context.rootGetters['files/filesToUpload'].filter((ftu) => {
				return ftu.uploaded === true;
			})

			let tasks = [];
			tasks[0] = {
				type: 21,
				question: {
					files: [{
						path: context.state.paths[21] + '/' + context.rootGetters['routes/route'].name +'/' + parseFileName(uploadedFiles[0].name)
					}]
				}
			};

			let payload = {};
			payload.tasks = tasks;
			payload.checkPoint = context.state.checkPoint;
			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				//console.log("storeImage res", res.data);
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
			})

			//console.log("storeSingleImageTask::payload", payload)
		},

		storeImageTaskType20(context)
		{
			

			let tasks = [];
			tasks[0] = {
				type: 0,
				question: {
					description: context.state.newTask.question.description,
					content: context.state.newTask.question.content
				}
			};

			let uploadedFiles = context.rootGetters['files/filesToUpload'].filter((ftu) => {
				return ftu.uploaded === true;
			})

			let files = uploadedFiles.map((ftu) => {
				//console.log("image", ftu)
				let file = {
					path: context.state.paths[20] + '/' + context.rootGetters['routes/route'].name +'/' + parseFileName(ftu.name),
					correctAnswer: context.state.newTask.answers[ftu.name]
				}

				return file;
			});

			let filesType11 = uploadedFiles.map((ftu) => {
				let n = {}
				n[window.localStorage.getItem('lang')] = context.state.newTask.answers[ftu.name]
				let file = {
					path: context.state.paths[20] + '/' + context.rootGetters['routes/route'].name +'/' + parseFileName(ftu.name),
					name: n
				}

				return file;
			});


			let answers = uploadedFiles.map((ftu) => {
				let answer = {
					content: context.state.newTask.answers[ftu.name]
				}

				return answer
			})

			tasks[1] = {
				type: 20,
				question: {
					content: 'Image',
					files: files,
					answers: answers

				}
				
			};

			tasks[2] = {
				type: 11,
				question: {
					content: 'ImageAnswer',
					files: filesType11
				}
			} 

			
			//console.log("## storeImageTaskType20", tasks);
			//return;

			let payload = {};
			payload.tasks = tasks;
			payload.checkPoint = context.state.checkPoint;
			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				console.log("storeImage res", res.data);
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
			})
		},

		storeImageTask(context)
		{
			let tasks = [];
			tasks[0] = {
				type: 0,
				question: {
					description: context.state.newTask.question.description,
					content: context.state.newTask.question.content
				}
			};

			let uploadedFiles = context.rootGetters['files/filesToUpload'].filter((ftu) => {
				return ftu.uploaded === true;
			})

			let files = uploadedFiles.map((ftu) => {
				//console.log("image", ftu)
				let file = {
					path: context.state.paths[6] + '/' + context.rootGetters['routes/route'].name +'/' + parseFileName(ftu.name)
				}

				return file;
			});


			let answers = uploadedFiles.map((ftu) => {
				let answer = {
					content: context.state.newTask.answers[ftu.name]
				}

				return answer
			})

			tasks[1] = {
				type: 6,
				question: {
					content: 'Image',
					files: files,
					answers: answers

				},
				
			} 

			
			let payload = {};
			payload.tasks = tasks;
			payload.checkPoint = context.state.checkPoint;
			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				//console.log("storeImage res", res.data);
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
			})
		},

		storeSlides(context)
		{
			
			let tasks = []
			let answers = Object.keys(context.state.newTask.answers)
			.map((key) => {
				let answer = {
					content: context.state.newTask.answers[key].content
				}

				return answer
			});

			tasks[0] = {
				type: 13,
				question: {
					answers: answers
				}
			};

			let payload = {
				tasks: tasks,
				checkPoint: context.state.checkPoint

			}

			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
			})
			.catch((err) => {
				console.log("storeSlides:: err", err)
			})

		},

		storeTask(context)
		{
			let payload = {}
			payload.tasks = [context.state.newTask];
			payload.checkPoint = context.state.checkPoint;
			axios.post(APIURL + 'checkpoints/store', payload)
			.then((res) => {
				//console.log(res.data)
				//context.dispatch('checkPoint')
				context.dispatch('setCheckpoint', res.data);
				context.commit('setAddCheckpoint', false)
			})
			.catch((err) => {
				console.log(err);
			})
		},

		setNewTaskQuestionDescription(context, payload)
		{
			context.commit('setNewTaskQuestionDescription', payload)
		},

		flushNewTask(context)
		{
			context.commit('flushNewTask');
		},

		setNewTaskQuestionContent(context, payload)
		{
			context.commit('setNewTaskQuestionContent', payload)
		},

		setNewTaskType(context, payload)
		{
			context.commit('setNewTaskType', payload)
			context.commit('checkpointsValidator/setValid', false, {root: true})
			context.commit('files/flushFilesToUpload', undefined, {root:true})
		},
		
		

		

		

	
		setFileUploaded(context, payload)
		{

			let uploaded = context.state.filesToUpload.findIndex((f) => {
				return f.name == payload
			});
			
			if(uploaded > -1)
			{
				context.commit('setFileUploaded', uploaded)
				
			}
		},
		

	


		
		
		

		setIsFetching(context, payload)
		{
			context.commit('setIsFetching', payload)
		},

		setShowEditCheckpointDialog(context, payload)
		{
			context.commit('setShowEditCheckpointDialog', payload)
		},

		checkPoint(context, payload)
		{
			context.commit('setIsFetching', true)
			axios.get(APIURL + 'trackinglocations/' + payload._id + '/grouped')
			.then((res) => {
					context.dispatch('files/setIsUploading', false, {root: true})
					context.commit('files/setFilesToUpload', [], {root:true})
					context.commit('setCheckpoint', res.data)
					context.dispatch('setShowEditCheckpointDialog', true)
					context.commit('setIsFetching', false)
					context.dispatch('setAddCheckpoint', false)


					context.dispatch('setEditTask', false)
				})
				.catch((err) => {
					context.commit('setIsFetching', false)
					console.log(err)
				})
			
		},

		setAddCheckpoint(context, payload)
		{
			
			context.commit('setAddCheckpoint', payload)
		},

		
	},

	mutations: {

		replaceSingleImage(state, payload)
		{
			let editableTask = state.editableTask;

			editableTask.question.files[0] = payload;

			state.editableTask = {};
			state.editableTask = editableTask;

			window.vm.$emit('singleImageReplaced');
		},

		removeTask(state, payload)
		{
			payload.task.delete = payload.type;
			state.removableTask = payload.task
		},

		setCameraTask(state, payload)
		{
			let editableTask = state.editableTask;
			payload.question.answers.pop();

			let answers = {}

			

			payload.question.answers.forEach((a) => {
				
				let lio = a.path.lastIndexOf('/') + 1;
				let name = a.path.substring(lio);

				answers[name] = {
					content: a.description,
					delete: false,
					isBeingReplaced: false
				};
			
			})

			
			payload.question.answers = answers;
			state.editableTask = payload;
			state.editTask = true; 
		},	

		deleteFile(state, payload)
		{
			let editableTask = state.editableTask;
			editableTask.question.files[payload].delete = true;
			state.editableTask = {}
			state.editableTask = editableTask;
			



		

		}, 

		cancelSeasonVideoIsBeinReplaced(state, payload)
		{
			let editableTask = state.editableTask;
			editableTask.question.files[payload].isBeingReplaced = false;

			state.editableTask = {};
			state.editableTask = editableTask;
		},

		replaceUploadedSeasonVideoFile(state, payload)
		{
			let values = Object.values(state.editableTask.question.files);
		 	let keys = Object.keys(state.editableTask.question.files);

		 	keys[payload.i] = payload.new;

		 	let files = {}

		 	

		 	keys.forEach((k,i) => {
		 		files[k] = values[i]
		 		files[k].path = k;
		 	});




		 	
		 	state.editableTask.question.answers = undefined;
		 	state.editableTask.question.files = files
		 	state.isBeingReplaced = false;
		 	
		},

		setSeasonVideoIsBeingReplaced(state, payload)
		{

			let editableTask = state.editableTask;

			editableTask.question.files[payload.name].isBeingReplaced = payload.value;

			state.editableTask = {};
			state.editableTask = editableTask;
		},

		setSeasonErrors(state, payload)
		{
			let newTask = state.newTask;
			payload.forEach((p) => {
				newTask.answers[p].error = translater.__('Duplicate');
			})

			state.newTask = {};
			state.newTask = newTask;

			//window.vm.$emit('seasonSet')
		},

		setSeasonErrorsEdit(state, payload)
		{
			let editableTask = state.editableTask;
			payload.forEach((p) => {
				editableTask.question.files[p].error = translater.__('Duplicate');

			})

			state.editableTask = {};
			state.editableTask = editableTask;
		},

		flushSeasonErrors(state)
		{
			let newTask = state.newTask;
			Object.keys(newTask.answers).forEach((a) => {
				newTask.answers[a].error = undefined
			})

			state.newTask = {}
			state.newTask = newTask;
		},

		flushSeasonErrorsEdit(state)
		{
			let editableTask = state.editableTask;
			Object.keys(editableTask.question.files).forEach((f) => {
				editableTask.question.files[f].error = undefined;
			})

			state.editableTask = {};
			state.editableTask = editableTask;
		},

		setSeason(state, payload)
		{
			
			let newTask = state.newTask;
			newTask.answers[payload.f.name].type = state.seasons[payload.c].type;
			state.newTask = {}
			state.newTask = newTask; 

			console.log("setSeason::mutations", state.newTask)
		},

		setSeasonEdit(state, payload)
		{
			let editableTask = state.editableTask;
			editableTask.question.files[payload.f].type = state.seasons[payload.c].type;
			state.editableTask = {};
			state.editableTask = editableTask;
		},

		addSeasonAnswer(state, payload)
		{
			
			let newTask = state.newTask;
			newTask.answers = {};
			

			let names = payload.files.map((f) => {
				return f.name;
			})

			names.forEach((n, i) => {
				newTask.answers[n] = {};
				
				newTask.answers[n] = {
					error: undefined,
					type: state.seasons[i].type
				}
			});

			state.newTask = {};
			state.newTask = newTask;
			
		}, 

		setSeasonVideos(state, payload)
		{
			let editableTask = state.editableTask;
			let files = {}

			payload.task.question.files.forEach((f) => {
				//console.log("payload", f)
				let lio = f.path.lastIndexOf('/') + 1;
				let name = f.path.substring(lio);
				let path = name;
				let file = {
					path:  path,
					type: f.type,
					uploaded: true,
					error: undefined,
					isBeingReplaced: false,
					delete: false
				}

				files[name] = file;
			})

			 //console.log("setSeasonVideos", files)

			payload.task.question.files = files;
			state.editableTask = {};
		    state.editableTask = payload.task
		    console.log("setSeasonVideos", state.editableTask)
			state.editTask = true;


		},

		setEditableAudioTaskAnswer(state, payload)
		{
			let editableTask = state.editableTask;
			editableTask.question.answers[payload.name].content = payload.value
			state.editableTask = {};
			state.editableTask = editableTask;
		},

		setSlides(state, payload)
		{
			let answers = {}
			let editableTask = payload
			editableTask.question.answers.forEach((a) => {
				a.edit = false;
				a.delete = false;
				let key = Math.random() * new Date().getTime();
				answers[key] = a;
			})
			editableTask.question.answers = answers;
			state.editableTask = editableTask;
			state.editTask = true;
			


		},

		setEditableTaskFilePath(state, payload)
		{
			
			state.editableTask.question.files[0].path = payload
			//console.log("setEditableTaskFilePath", payload)
		},

		replaceUploadedVideoFile(state, payload)
		{
			
			let editableTask = state.editableTask;
			editableTask.question.files[0].path = payload
			state.editableTask = {};
			state.editableTask = editableTask;
			state.isBeingReplaced = false; 

			//console.log("replaceUploadedVideoFile::mutation", state.editableTask)

			
		},

		setIsBeingReplacedGlobal(state, payload)
		{
			state.isBeingReplaced = payload
		},

		flushIsBeingReplaced(state, payload)
		{
			let editableTask = state.editableTask;

			if(typeof editableTask.question.answers !== 'undefined')
			{
				Object.keys(editableTask.question.answers).forEach((a) => {
					editableTask.question.answers[a].isBeingReplaced = false;
					if(typeof editableTask.question.answers[a].matchingImage !== 'undefined')
					{
						editableTask.question.answers[a].matchingImage.isBeingReplaced = false;
					}
				})
			}

			state.isBeingReplaced = false;
		},

		replaceUploadedAudioTaskImage(state, payload)
		{
			let editableTask = state.editableTask;
			let path = payload.path;
			editableTask.question.answers[payload.audio].matchingImage.path = path + payload.new;

			state.editableTask = editableTask;
			//console.log("replaceUploadedAudioTaskImage", state.editableTask)
		},

		replaceUploadedFile(state, payload)
		{
			

		 	let values = Object.values(state.editableTask.question.answers);
		 	let keys = Object.keys(state.editableTask.question.answers);

		 	keys[payload.i] = payload.new;

		 	let answers = {}

		 	keys.forEach((k,i) => {
		 		answers[k] = values[i]
		 	});


		 	
		 	state.editableTask.question.answers = undefined;
		 	state.editableTask.question.answers = answers 





		},

	

		setAnswerImageIsBeingReplaced(state, payload)
		{

			let isBeingReplaced = true
			if(!payload.value)
			{
				isBeingReplaced = false
			}

			state.isBeingReplaced = isBeingReplaced

			let editableTask = state.editableTask;
			editableTask.question.answers[payload.name].matchingImage.isBeingReplaced = payload.value;

			state.editableTask = {};

			state.editableTask = editableTask;
			//console.log("setAnswerImageIsBeingReplaced", state.editableTask)
			
		},

		setIsBeingReplaced(state, payload)
		{
			let isBeingReplaced = true
			if(!payload.value)
			{
				isBeingReplaced = false
			}

			state.isBeingReplaced = isBeingReplaced
			let editableTask = state.editableTask;
			editableTask.question.answers[payload.name].isBeingReplaced = payload.value;

			state.editableTask = {};

			state.editableTask = editableTask;
			//console.log("setIsBeingReplaced", state.editableTask)
			


		},

		setEditableTaskDescription(state, payload)
		{
			state.editableTask.question.description = payload

		},

		setEditableTaskContent(state, payload)
		{
			state.editableTask.question.content = payload;
		},

		setEditTask(state, payload)
		{
			state.editTask = payload
		},

		editTask(state, payload)
		{
			state.editTask = true;
			//console.log("####### editTask::payload", payload)
			state.editableTask = payload
			
		},

		flushVideo(state, payload)
		{
			state.video = {
				full: undefined,
				url: undefined
			}
		},

		setVideoFull(state, payload)
		{
			state.video.full = payload
		},

		setVideoUrl(state, payload)
		{
			state.video.url = payload
		},

		deleteSlide(state, payload)
		{
			let slides = state.newTask.answers;
			if(payload.edit === true)
			{
				slides = state.editableTask.question.answers;
			}
			delete slides[payload.key]
			if(payload.edit !== true)
			{
				state.newTask.answers = {};
				state.newTask.answers = slides
			} else {
				state.editableTask.question.answers = {};
				state.editableTask.question.answers = slides;
			}
			//console.log("deleteSlide")
			//window.vm.$emit('updateSlides')
		},


		cancelDeleteSlide(state, payload)
		{
			let slides = state.newTask.answers;
			if(payload.edit === true)
			{
				slides = state.editableTask.question.answers;
			}
			slides[payload.key].delete = false
			if(payload.edit !== true)
			{
				state.newTask.answers = {};
				state.newTask.answers = slides;
			} else {
				state.editableTask.question.answers = {};
				state.editableTask.question.answers = slides;
			}
			//window.vm.$emit('updateSlides')
		},

		confirmSlideDelete(state, payload)
		{
			let slides = state.newTask.answers;
			if(payload.edit === true)
			{
				slides = state.editableTask.question.answers;
			}
			slides[payload.key].delete = true;
			if(payload.edit !== true)
			{
				state.newTask.answers = {};
				state.newTask.answers = slides;
			} else {
				state.editableTask.question.answers = {};
				state.editableTask.question.answers = slides
			}
			//window.vm.$emit('updateSlides')
		},

		updateSlide(state, payload)
		{
			state.editableSlide.content = payload;
			state.editableSlide.edit = false;
			state.editableSlide = undefined;
		},

		setIsEditingSlide(state, payload)
		{
			state.isEditingSlide = payload
		},

		editSlide(state, payload)
		{
			state.editableSlide = state.newTask.answers[payload.key]
			state.editableSlide.edit = true;
			state.isEditingSlide = true
		},

		editSlideEdit(state, payload)
		{
			state.editableSlide = state.editableTask.question.answers[payload.key];
			state.editableSlide._id = payload.key;
			state.editableSlide.edit = true;
			state.isEditingSlide = true;
			//console.log("editSlideEdit", state.editableSlide)
		},


		deleteAnswer(state, payload)
		{
			let answers = state.newTask.answers;
			delete answers[payload];
			state.newTask.answers = answers
			
		},

		

		
		
		
		

		setSlide(state, payload)
		{
			state.slide = payload
		},

		

		flushAudioTaskAnswerImagesToUpload(state)
		{
			state.audioTaskAnswerImagesToUpload = {};
		},

		addAnswer(state, payload)
		{
			let answers = state.newTask.answers;
			if(typeof answers === 'undefined')
			{
				answers = {};
			}
			answers[payload] = "";

			state.newTask.answers = answers 

			
		},

		setNewTaskAnswer(state, payload)
		{
			let newTask = state.newTask;
			if(typeof newTask.answers === 'undefined')
			{
				newTask.answers = {}
			}
			//console.log("hep", newTask)
			newTask.answers[payload.name] = payload.value
			state.newTask = {};
			state.newTask = newTask;
		},



		// TODO: refactor other setEditableAsnwer calls to match this new implementation
		setEditableTaskAnswer(state, payload)
		{
			let editableTask = state.editableTask;
			if(typeof editableTask.question.answers === 'undefined')
			{
				editableTask.question.answers = {}
			}
		
			editableTask.question.answers[payload.name] = payload.value
			state.editableTask = {};
			state.editableTask = editableTask;
		},

		setNewTaskQuestionDescription(state, payload)
		{
			state.newTask.question.description = payload
		},

		flushNewTask(state)
		{
			state.newTask = {
				type: 0,
				question: {
					content: '',
					description: ''
				},
				answers: undefined
			}
		},

		setNewTaskQuestionContent(state, payload)
		{
			state.newTask.question.content = payload
		},

		setNewTaskType(state, payload)
		{
			state.newTask = {
				answers: undefined,
				question: {
					content: '',
					description: ''
				},

				type: payload
			}
		},

	



		

		setFileUploaded(state, payload)
		{
			let filesToUpload = state.filesToUpload;
			filesToUpload[payload].uploaded = true;
			filesToUpload[payload].error = undefined;
			state.filesToUpload = filesToUpload;
			state.filesToUpload = [];
			state.filesToUpload = filesToUpload;
			//window.vm.$emit("fileUploaded");
		},
		// upload specific
		addUploadedFile(state, payload)
		{
			let uploadedFiles = state.uploadedFiles;
			uploadedFiles.push(payload);
			state.uploadedFiles = uploadedFiles;
		},

		/*flushFilesToUpload(state)
		{
			state.filesToUpload = []
			state.uploadedFiles = []
		},*/
		// upload specific
		setFilesToUpload(state, payload)
		{
			let filesToUpload = state.filesToUpload;
			filesToUpload = payload.concat(filesToUpload);
			state.filesToUpload = filesToUpload
		},

		setAddCheckpoint(state, payload)
		{
			state.add = payload
		},

		setIsFetching(state, payload)
		{
			
			state.isFetching = payload
		},

		setIsFetchingSlide(state, payload)
		{
			state.isFetchingSlide = payload
		},

		setShowEditCheckpointDialog(state, payload)
		{
			state.showEditCheckpointDialog = payload;
		},

		setCheckpoint(state, payload)
		{
			

			payload.properties.subTasks = payload.properties.subTasks.map((st) => {
				st.delete = false;
				st.draggable = false;

				return st;
			})

			state.checkPoint = payload;
		},
		// upload specific
		setIsUploading(state, payload)
		{
			
			state.isUploading = payload
		}
	},

	getters: {


	
		

		isBeingReplaced(state)
		{
			return state.isBeingReplaced;
		},

		editableTask(state)
		{
			return state.editableTask;
		},

		editTask(state)
		{
			return state.editTask;
		},

		video(state)
		{
			return state.video;
		},

		isEditingSlide(state)
		{
			return state.isEditingSlide;
		},

		/*season(state)
		{
			return state.season
		},*/

		/*defaultSeasonsSet(state)
		{
			return state.defaultSeasonsSet;
		},*/

		seasons(state)
		{
			return state.seasons
		},

		slide(state)
		{
			return state.slide;
		},

		

		

		/*uploadImageAnswer(state)
		{
			return state.uploadImageAnswer
		},*/

		answers(state)
		{
			return state.newTask.answers
		},

		showEditCheckpointDialog(state)
		{
			return state.showEditCheckpointDialog;
		},

		checkPoint(state)
		{
			return state.checkPoint;
		},

		isFetching(state)
		{
			return state.isFetching
		},

		add(state)
		{
			return state.add
		},

		/*isUploading(state)
		{
			return state.isUploading;
		},*/

		filesToUpload(state)
		{
			return state.filesToUpload;
		},

		/*uploadProgress(state)
		{
			return state.uploadProgress;
		}*/

		showUploadForm(state)
		{
			let show = false;
			if(typeof state.validMimeTypes[state.newTask.type] !== 'undefined')
			{
				show = true;
			}
			
			return show;

		},

		taskTypes(state)
		{
			return state.taskTypes;
		},

		newTask(state)
		{
			return state.newTask;
		},

		answersRequired(state)
		{
			let answersRequired = false;
			let found = Object.keys(state.paths).find((type) => {
				return type == state.newTask.type;
			})

			if(found) { answersRequired = true; }

			return answersRequired;
		},

		fullPath(state)
		{
			return APIURL + state.paths[state.newTask.type]
		},

		fullPathEdit(state)
		{
			return APIURL + state.paths[state.editableTask.type]
		},

		fullPaths(state)
		{
			let fullPaths = {};
			let types = Object.keys(state.paths).forEach((type) => {
				fullPaths[state.paths[type]] = APIURL + state.paths[type]
			
			})

			return fullPaths


		},

		paths(state)
		{
			return state.paths;
		},

		editableSlide(state)
		{
			return state.editableSlide;
		}

		


	}
}